import type { SpeechService, SpeechSession } from '../../ports/speech'
import { BackendError } from '../../errors'
import type { Transport } from './transport'

/**
 * Real-time STT transport (WebSocket / chunked upload) is still TBD with the backend.
 * Until it's wired, use `createMockBackendClient().speech` for dictation in dev.
 */
export class HttpSpeechService implements SpeechService {
  constructor(private readonly _t: Transport) {}

  async start(): Promise<SpeechSession> {
    throw new BackendError({
      code: 'unknown',
      message: 'HTTP speech adapter not wired yet — backend STT transport (WebSocket) TBD.',
    })
  }
}
